import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';

class ShelbyDetailedBill extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatTransactions(txns) {
    return ObjectUtils.formatStringAsJSONArray(txns).map(txn => ({
      'Payment ID': txn.paymentTransactionId,
      'Payment Date': moment(txn.paymentDate.$date)
        .utc()
        .format(),
      'Payment Amount': `${txn.paymentAmount.value} ${txn.paymentAmount.currencyCode}`,
    }));
  }

  formatClientPaymentsRequests(payments) {
    return ObjectUtils.formatStringAsJSONArray(payments).map(payment => ({
      'Amount Paid': payment.amountPaid.value,
      'Total Transaction Amount': payment.totalTransactionAmount.value,
      'Payment Date': payment.paymentDate.$date,
      TaxYear: payment.taxYear,
      'Email Address': payment.emailAddress,
      'Phone Number': payment.phoneNumber,
      'Payment Method Type': payment.paymentMethodType,
    }));
  }

  formatClientPayments(payments) {
    return ObjectUtils.formatStringAsJSONArray(payments).map(payment => ({
      'Payment Amount': payment.paymentAmount.value,
      'Payment Date': moment(payment.paymentDate.$date)
        .utc()
        .format(),
      'PayIt Transaction Id': payment.payItTransactionId,
      'Control Year': payment.controlYear,
      'Control Number': payment.controlNumber,
    }));
  }

  render() {
    const { bill, } = this.props;
    const paymentTransactions = this.formatTransactions(bill.paymentTransactions);
    const paymentTransactionModel = Grid.toModelFromList(paymentTransactions);
    const clientPaymentsRequests = this.formatClientPaymentsRequests(bill.clientPaymentRequests);
    const clientPaymentsRequestsModel = Grid.toModelFromList(clientPaymentsRequests);
    const clientPayments = this.formatClientPayments(bill.clientPayments);
    const clientPaymentsModel = Grid.toModelFromList(clientPayments);

    const items = VerticalLabelList.toList({
      'Due Date': moment(bill.dueDate)
        .utc()
        .format(),
      Paid: bill.paid,
      'Tax Year': bill.taxYear,
      'Tax Due': bill.taxDue,
      'Bill Balance': bill.billBalance_value,
      'Client Balance': bill.clientBillBalance_value,
      'PayIt Balance': bill.payItBalance_value,
      'Fees Due': bill.feesDue_value,
      'Interest Due': bill.interestDue_value,
      'Assessed Value': bill.assessedValue_value,
      'Owner Plus Four': bill.ownerPlusFour,
      'Original Due Date': moment(bill.originalDueDate)
        .utc()
        .format(),
      'Owner Name': bill.ownerName,
      'Street Number': bill.streetNumber,
      'Street Name': bill.streetName,
      'Owner Apt': bill.ownerApt,
      'Owner City': bill.ownerCity,
      'Owner State': bill.ownerState,
      'Owner Zip Code': bill.ownerZipCode,
      'Payment Allowed': bill.paymentAllowed,
      'External Account Id': bill.externalAccountId,
      'External Bill Id': bill.externalBillId,
      Id: bill.id,
    });

    return (
      <div>
        <div>
          <FieldSet title="Bill Summary" style={{ maxHeight: '300px', }}>
            <VerticalLabelList items={items} />
          </FieldSet>
        </div>

        <div>
          <FieldSet title="Payment Transactions" style={{ maxHeight: '300px', }}>
            <Grid
              headers={paymentTransactionModel.headers}
              rows={paymentTransactionModel.format(paymentTransactions)}
            />
          </FieldSet>
        </div>
        <div>
          <FieldSet title="Client Payment Request" style={{ maxHeight: '300px', }}>
            <Grid
              headers={clientPaymentsRequestsModel.headers}
              rows={clientPaymentsRequestsModel.format(clientPaymentsRequests)}
            />
          </FieldSet>
        </div>
        <div>
          <FieldSet title="Client Payments" style={{ maxHeight: '300px', }}>
            <Grid
              headers={clientPaymentsModel.headers}
              rows={clientPaymentsModel.format(clientPayments)}
            />
          </FieldSet>
        </div>
      </div>
    );
  }
}

ShelbyDetailedBill.defaultProps = {};

ShelbyDetailedBill.propTypes = {
  bill: PropTypes.instanceOf(Object).isRequired,
};

export default ShelbyDetailedBill;
